/**
 * Converts size in independent pixels to size in real device pixels
 * @param {Number} size - size in device independent pixels
 * @returns {Number|Null} - `null` if independent to device pixel ration is not known
 */
export default function getRealSize(size) {
  if (typeof window === "undefined") return null;
  return size * window.devicePixelRatio;
}
